import styled from "styled-components";

export const InnerBox = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 15px;
  padding: 0;
  margin: 0;
  overflow-y: auto;
  overflow-x: clip;

  @media (max-width: 520px) {
    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  }
  @media (max-width: 360px) {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
`;
